import MediaSelector from '../../../../../Components/DialogLaunchers/MediaSelector/MediaSelector';
import { IFile } from '../VisitorTypes';
import { IbssComponent } from '../../../../../Components/Core/BaseComponent/IbssComponent';

class ImageForm extends IbssComponent<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    };

    public render(): JSX.Element
    {
        return (
            <div className='m-4'>
                <MediaSelector
                    required
                    options={this.props.images.map(i => ({ name: i.name, url: i.path }))}
                    imageSelected={file => this.props.onValueChange(file.url)}
                    uploadFile={(filename, file, processAsMap) => this.props.uploadFile(filename, file, processAsMap)}
                    defaultSelectedImage={this.props.value}
                />
            </div>
        )
    }
}

export default ImageForm;

export interface IProps
{
    onValueChange: (value: string) => void;
    value: string;
    images: IFile[];
    uploadFile: (filename: string, file: FormData, processAsMap: boolean) => Promise<void>;
}

export interface IState
{
}